/* eslint-disable camelcase */
import $ from "jquery";
import Notices from "./Notices";
import AjaxBlocking from "./AjaxBlocking";

export default class QuickLook {
    constructor(className) {
        this.product = Array.from(document.querySelectorAll(`.${className}`));
        this.box = document.getElementById("jsQuickLookBox");
        this.closeBtn = document.getElementById("jsQuickLookBoxClose");
        this.overlay = document.getElementById("jsQuickLookBoxOverlay");
        this.isOpen = false;

        if (this.product.length) {
            this.events();
        }
    }

    init() {
        this.events();
    }

    events() {
        const self = this;

        $("body").on("click", ".jsQuickLook", function (e) {
            e.preventDefault();
            self.openQuickLook(this, e);
        });

        this.product.forEach((item) =>
            item.addEventListener("click", function (e) {
                e.preventDefault();
                self.openQuickLook(this, e);
            })
        );

        this.closeBtn.addEventListener("click", (e) => {
            this.closeQuickLook();
        });

        this.overlay.addEventListener("click", (e) => {
            if (this.isOpen) {
                if (e.target !== this.box && e.target !== this.product) {
                    this.closeQuickLook();
                    this.isOpen = false;
                }
            }
        });
    }

    openQuickLook(element, event) {
        this.isOpen = true;
        const data = JSON.parse(element.dataset.overview);
        this.generateTemplateAjax(
            element,
            data.id,
            data.name,
            data.image,
            data.description,
            data.link,
            data.gross_retail,
            data.net_retail,
            data.gross_wholesale,
            data.net_wholesale
        );
        this.blockForAjax(element);
    }

    closeQuickLook(e) {
        this.box.classList.remove("open");
        this.overlay.classList.remove("open");
        document.body.style["overflow-y"] = "";
        document.body.style["overflow-x"] = "";
        if (this.isOpen) {
            this.isOpen = false;
        }
    }

    generateTemplateAjax(
        element,
        id,
        title,
        image,
        description,
        link,
        grossRetail,
        netRetail,
        grossWholesale,
        netWholesale
    ) {
        fetch(window.global.ajax_url + "?action=GetQuickLookView", {
            method: "POST", //* GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                // "Content-Type": "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
            body: new URLSearchParams({
                security: window.global.security,
                id: id,
                title: title,
                image: image,
                description: description,
                link: link,
                grossRetail: grossRetail,
                netRetail: netRetail,
                grossWholesale: grossWholesale,
                netWholesale: netWholesale,
            }),
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.success) {
                    this.box.querySelector("#jsQuickLookOverview").innerHTML =
                        data.data;
                    this.box.classList.add("open");
                    this.overlay.classList.add("open");
                    document.body.style["overflow-y"] = "hidden";
                    document.body.style["overflow-x"] = "hidden";
                    // this.changeQuantity();
                    // this.changeQuantityButton();
                    this.unblockForAjax(element);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    blockForAjax(e) {
        const myBlock = new AjaxBlocking();
        myBlock.blockOnAjax(e);
    }

    unblockForAjax(e) {
        const myBlock = new AjaxBlocking();
        myBlock.unblockOnAjax(e);
    }

    changeQuantity() {
        const product_cart = document.getElementById("jsQuickLookOverview");
        const quantity = product_cart.querySelector(".quantity");
        const plus_button = quantity.querySelector(".quantity-plus");
        const minus_button = quantity.querySelector(".quantity-minus");
        const qty = quantity.querySelector(".qty");
        let currVal = parseInt(qty.value, 10);

        plus_button.addEventListener("click", () => {
            const value = parseInt(qty.value, 10);
            const maxVal = parseInt(qty.max, 10);

            if (!maxVal || (maxVal && value < maxVal)) {
                qty.value = value + 1;
            } else {
                qty.value = maxVal;
            }
        });

        minus_button.addEventListener("click", () => {
            const value = parseInt(qty.value, 10);
            const minVal = parseInt(qty.min, 10);

            if ((!minVal && value > 1) || (minVal && minVal < value)) {
                qty.value = value - 1;
            } else if (minVal && minVal >= value) {
                qty.value = minVal;
            } else {
                qty.value = value;
            }
        });

        qty.addEventListener("change", () => {
            const newQtyVal = parseInt(qty.value, 10);

            if (!isNaN(newQtyVal)) {
                currVal = newQtyVal === 0 ? 1 : Math.abs(newQtyVal);
                qty.value = currVal;
            } else {
                qty.value = currVal;
            }
        });

        qty.addEventListener("keyup", () => {
            const newQtyVal = parseInt(qty.value, 10);

            if (!isNaN(newQtyVal)) {
                currVal = newQtyVal === 0 ? 1 : Math.abs(newQtyVal);
                qty.value = currVal;
            } else {
                qty.value = currVal;
            }
        });
    }

    changeQuantityButton() {
        const buttons = document.getElementById("qty-buttons");

        if (buttons) {
            buttons
                .querySelectorAll(".single-product__attributes__attribute")
                .forEach((el) => {
                    el.addEventListener("click", (e) => {
                        const active = buttons.querySelector(".btn--black");
                        if (el) {
                            if (active) {
                                active.classList.add("btn--black-transparent");
                                active.classList.remove("btn--black");
                                active.classList.remove("js-active");
                            }
                            e.target.classList.remove("btn--black-transparent");
                            e.target.classList.add("btn--black");
                            e.target.classList.add("js-active");
                        }
                    });
                });
        }
    }
}
